module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAOFJREFUOE+lkisOhDAURS+GFeDA4VAkGAIWdlCBgzUgSUhQOBaBJCyBBYDFYDGg2ACukzaTCaWZJszUNGnPeff1o1FKKX4Y2l3ctg1VVWGaJl4uDEOUZQnLsoTykphlGYZhEKAoitC2rVp0XRfHcQiQYRiY51kt2raN8zwFSNd1rOuqFuM4xrIsAuQ4jtS+dMau65DnuSA2TYMkSdSJbJddRFEUHKzrGmmaSg8mJTJiHEcQQjjc9z2CIFCLTGBtsfk6fN/nHXie91nmid+Ee8y1ABdN03z06fZ9x3/io7g3/ALILILXWlw2BQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/my.png
// module id = 4Ysc
// module chunks = 12